import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'lib-document-icon',
  imports: [],
  template: `<i class="{{ iconInfo().icon }}"></i>`,
  host: {
    '[class]':
      '`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm ${iconInfo().color}`',
  },
})
export class DocumentIcon {
  readonly fileName = input.required<string>();

  readonly iconInfo = computed(() => this.getIconInfo(this.fileName()));

  private getIconInfo(fileName: string): { icon: string; color: string } {
    const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
    const map: Record<string, { icon: string; color: string }> = {
      pdf: { icon: 'pi pi-file-pdf', color: 'bg-red-100 text-red-600' },
      doc: { icon: 'pi pi-file-word', color: 'bg-blue-100 text-blue-600' },
      docx: { icon: 'pi pi-file-word', color: 'bg-blue-100 text-blue-600' },
      xls: { icon: 'pi pi-file-excel', color: 'bg-green-100 text-green-600' },
      xlsx: { icon: 'pi pi-file-excel', color: 'bg-green-100 text-green-600' },
      csv: { icon: 'pi pi-file-excel', color: 'bg-green-100 text-green-600' },
      png: { icon: 'pi pi-image', color: 'bg-purple-100 text-purple-600' },
      jpg: { icon: 'pi pi-image', color: 'bg-purple-100 text-purple-600' },
      jpeg: { icon: 'pi pi-image', color: 'bg-purple-100 text-purple-600' },
    };
    return (
      map[ext] ?? { icon: 'pi pi-file', color: 'bg-gray-100 text-gray-600' }
    );
  }
}
